import React from "react"
import PropTypes from "prop-types"

export default function AuthPageContent({ children }) {
  return <div className="sdk-auth-page-content">{children}</div>
}

AuthPageContent.propTypes = {
  children: PropTypes.node.isRequired,
}
